import { createFileRoute } from '@tanstack/react-router'
import { FnsActionPage } from '@/features/forms-and-surveys/pages'

export const Route = createFileRoute('/_authenticated/surveys/create/')({
  component: FnsActionPage,
})
